import gql from "graphql-tag";

export const UPDATE = gql`
  mutation updateUser($user: UserInput!) {
    updateUser(user: $user)
  }
`;

export const ADD_TO_STRIPE = gql`
  mutation addUserToStripe($userId: ID!) {
    addUserToStripe(userId: $userId)
  }
`;

export const UPDATE_USER_PAYMENT = gql`
  mutation updateUserPayment(
    $userId: ID!
    $payment: PaymentMethodInput!
    $cardId: String!
  ) {
    updateUserPayment(userId: $userId, payment: $payment, cardId: $cardId)
  }
`;

export const ADD_USER_PAYMENT = gql`
  mutation addUserPayment($userId: ID!, $payment: PaymentMethodInput!) {
    addUserPayment(userId: $userId, payment: $payment)
  }
`;

export const LIKE_POST = gql`
  mutation userLikePost($userId: ID!, $postId: ID!) {
    userLikePost(userId: $userId, postId: $postId)
  }
`;

export const LIKE_DISH = gql`
  mutation userLikeDish($userId: ID!, $dishId: ID!) {
    userLikeDish(userId: $userId, dishId: $dishId)
  }
`;
export const FAV = gql`
  mutation addSavedItems($userId: ID!, $itemsToAdd: SavedItemsInput!) {
    addSavedItems(userId: $userId, itemsToAdd: $itemsToAdd)
  }
`;

export const UNFAV = gql`
    mutation deleteSavedItems($userId: ID!, $itemsToDelete: SavedItemsInput!) {
        deleteSavedItems(userId: $userId, itemsToDelete: $itemsToDelete)
    }
`;

export const CREATE_SUPPORT_PROFILE = gql`
  mutation createSupportProfile($userId: ID!) {
    createSupportProfile(userId: $userId)
  }
`;
export const SUBMIT_FEEDBACK = gql`
  mutation submitFeedback($type: FEEDBACK_TYPE!, $feedback: String!) {
    submitFeedback(type: $type,feedback:$feedback)
  }
`;
